import React from "react";
import { useTranslation } from "react-i18next";
import { ServiceCard } from "@/components/cards/ServiceCard";
import { SERVICES } from "@/data/services";
import { useLocalize } from "@/data/localize";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function FeaturedServices({ limit = 9 }) {
    const { t } = useTranslation();
    const { localizeList } = useLocalize();
    const list = localizeList(SERVICES.slice(0, limit));
    return (
        <section data-testid="featured-services" className="container-page section-y">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {list.map((s) => (
                    <ServiceCard key={s.slug} service={s} />
                ))}
            </div>
            <div className="mt-8">
                <Link
                    to="/services"
                    className="inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--brand-teal-2)] hover:gap-2 transition-[gap]"
                    data-testid="featured-services-view-all"
                >
                    {t("cta.viewAllServicesArrow")}
                    <ArrowRight className="h-4 w-4" />
                </Link>
            </div>
        </section>
    );
}
